import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2a2bbbfd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-expand navbar-light navbar-bg" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "hamburger align-self-center" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "navbar-collapse collapse" }
const _hoisted_5 = { class: "navbar-nav navbar-align align-items-center" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "ms-3 fw-bolder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dropdown_ui = _resolveComponent("dropdown-ui")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", {
      class: "sidebar-toggle cursor-pointer",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeSidebar && _ctx.changeSidebar(...args)))
    }, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user.depots, (d) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "nav-item",
            onClick: ($event: any) => (_ctx.setDepo(d.depoId))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["mx-3 cursor-pointer", {'fw-bolder': d.depoId === _ctx.depoId}])
            }, _toDisplayString(d.depoName), 3)
          ], 8, _hoisted_6))
        }), 256)),
        _createElementVNode("li", _hoisted_7, [
          _createVNode(_component_dropdown_ui, null, {
            button: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.user.login), 1)
              ])
            ]),
            list: _withCtx(() => [
              _createElementVNode("div", {
                class: "dropdown-item cursor-pointer",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
              }, " Выход ")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}